<script>
	import { page } from "$app/stores";
	import { watchObject, tryEval } from "cando-util";

	import { store } from "$lib/utilities/store";
	import {
		action,
		clearRecordSelection,
	} from "$lib/sections/Admin/Management/tableFunctions.js";
	import { formUpdate } from "$lib/sections/Admin/formUpdate";
	import { setResponsesDb } from "$lib/sections/FormSubmission/getResponsesDb.js";

	import ScreenSize from "$lib/components/ScreenSize.svelte";
	import Table from "$lib/sections/Admin/Table.svelte";
	import RecordDetail from "$lib/sections/Admin/Management/RecordDetail.svelte";
	import Form from "$lib/sections/Form.svelte";
	import SettingsFormInput from "$lib/sections/Admin/SettingsFormInput.svelte";

	const col = "userSubmissions";

	let screenWidth;
	let breakpoint;

	$: leftMargin = screenWidth > 1440 ? (screenWidth - 1440) / 2 : 0;

	$: url = $page.url;
	$: currentDocId = url.searchParams.get("docId");
	$: lang = window.location.pathname.includes(`/${$page.data.lang}/`)
		? $page.data.lang
		: "";

	$: record = $store?.[col]?.docs?.[currentDocId] || {};
	$: watchObject(record, "record");
	$: watchObject($store, "store");
	const getCaseDoc = (docId, col = "userCases") =>
		$store?.[col]?.docs?.[docId] || null;
	$: watchObject(getCaseDoc, "getCaseDoc");
	const getSubmissionDoc = (docId, col = "userSubmissions") =>
		$store?.[col]?.docs?.[docId] || null;
	$: watchObject(getSubmissionDoc, "getSubmissionDoc");

	let responsesSet;

	$: if (currentDocId && Object.keys(record).length > 0) {
		const {
			col,
			settingId,
			formName,
			collection,
			appVersion,
			buildVersion,
		} = record;
		responsesSet = setResponsesDb(
			col,
			settingId,
			formName,
			collection,
			record,
			appVersion,
			buildVersion,
		);
	} else {
		responsesSet = false;
	}

	$: data = {
		...$page.data,
		content: {
			...$page.data?.content,
			...Object.keys($store)
				.filter((k) => $store[k]?.docs)
				.reduce(
					(a, v) => ({
						...a,
						[v]: $store[v].docs,
					}),
					{},
				),
		},
	};

	$: tfFunction =
		$store?.settings?.docs?.["App Settings"]?.tfUserSubmissions?.value ||
		`[]`;
	$: tableFields = tryEval(tfFunction);

	$: dbFunction =
		$store?.settings?.docs?.["App Settings"]?.dbUserSubmissions?.value ||
		`(() => console.log('no dash board function'))()`;
	$: dashboard = tryEval(dbFunction);

	let loading = true;
	let updateTimeout;

	const settingUpdate = async (event) => {
		if (updateTimeout) {
			clearTimeout(updateTimeout);
		}

		updateTimeout = setTimeout(async () => {
			await formUpdate(
				event,
				$store,
				loading,
				"settings",
				"App Settings",
				"",
			);
		}, 1000);
	};
</script>

<ScreenSize bind:width={screenWidth} bind:breakpoint showBreakpoint={false} />

<div
	class="max-w-[1440px] px-2 sm:px-4"
	style={`margin-left: ${leftMargin}px;`}
>
	<div class="w-full">
		<section class="mt-6 space-y-4">
			{#if !!currentDocId}
				<RecordDetail
					{col}
					docId={currentDocId}
					onClose={clearRecordSelection}
					{tableFields}
					allowFormEdit={!!$store?.userRoles?.admin}
				/>

				<div><hr /></div>

				{#if responsesSet}
					<Form
						lang={$page?.data?.lang}
						{data}
						col={record.col}
						settingId={record.settingId}
						allowReset={false}
						allowHideTags={false}
					/>
				{/if}
			{:else}
				{#if typeof dashboard === "function"}
					{@html dashboard()}
				{/if}
				<Table
					{col}
					includeAll={true}
					{action}
					{tableFields}
					adjustLeftMargin={false}
					allowEdit={false}
					allowTableColumnEdit={!!$store?.userRoles?.admin}
				/>
			{/if}
			{#if $store?.userRoles?.admin}
				<div><hr /></div>
				{#if $store?.settings?.docs?.["App Settings"]?.dbUserSubmissions}
					<div class="shadow-xl collapse collapse-arrow bg-base-300">
						<input type="checkbox" />
						<div class="font-medium collapse-title">
							Dashboard Function
						</div>
						<div class="collapse-content">
							<SettingsFormInput
								col={"settings"}
								settingId={"App Settings"}
								fld={{
									key: "dbUserSubmissions",
									...$store?.settings?.docs?.["App Settings"]
										?.dbUserSubmissions,
								}}
								{lang}
								handleChange={settingUpdate}
							/>
						</div>
					</div>
				{:else}
					<div>
						No dashboard function found in App Settings
						(dbUserSubmissions)
					</div>
				{/if}
				<div><hr /></div>
				{#if $store?.settings?.docs?.["App Settings"]?.tfUserSubmissions}
					<div class="shadow-xl collapse collapse-arrow bg-base-300">
						<input type="checkbox" />
						<div class="font-medium collapse-title">
							Table Fields Function
						</div>
						<div class="collapse-content">
							<SettingsFormInput
								col={"settings"}
								settingId={"App Settings"}
								fld={{
									key: "tfUserSubmissions",
									...$store?.settings?.docs?.["App Settings"]
										?.tfUserSubmissions,
								}}
								{lang}
								handleChange={settingUpdate}
							/>
						</div>
					</div>
				{:else}
					<div>
						No tableFields function found in App Settings
						(tfUserSubmissions)
					</div>
				{/if}
				<div><hr /></div>
			{/if}
		</section>
	</div>
</div>
